var initializeBiosBlock = function(block){

	jQuery(".tab-menu > li", block).click(function(){
		
		var menuItem = jQuery(this);
		var contentID = menuItem.attr("data-content");
		
		jQuery(".tab-menu > li.active", block).removeClass("active");
		menuItem.addClass("active");

		jQuery(".tab-content > .active", block).removeClass("active");
		jQuery(".tab-content > div[data-content='"+contentID+"']", block).addClass("active");
		
		jQuery("html,body").animate({ scrollTop: jQuery(".tab-content", block).offset().top - 40 }, 'slow');
		
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-bios').each(function(){
		initializeBiosBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=bios', initializeBiosBlock);
